import React, { useState } from 'react';
import logo from '../../../images/caring_universities.png';
import t from '../../translate';
import LanguageSwitch from './languageSwitch';

const Footer = (props) => {

  return (
    <div className="footer">
      <div className="container">
        <div className="title">Contact</div>
        <div className="row">
          <div className="column">
            Vrije Universiteit<br />
            Antwoordnummer 2941<br />
            2544, Sectie Klinische Psychologie<br />
            t.a.v. Sascha Struijs, kamer MF A518<br />
            1000 SN Amsterdam<br />
          </div>
          <div className="column">
              <a href="mailto:moodlift@vu.nl">moodlift@vu.nl</a><br />
              <div className={parseInt(props.language) === 0 ? 'hidden' : 'languageSwitch'}>
                <span className={props.language === 1 ? 'active pointer' : 'pointer'} onClick={() => props.changeLanguage(1)}>Nederlands</span> | <span className={props.language === 2 ? 'active pointer' : 'pointer'} onClick={() => props.changeLanguage(2)}>English</span>
              </div>
          </div>
          <div className="column">
            <a href="https://moodlift.nl/nl/meer-over-moodlift/" target="_blank">{t("Meer informatie")}</a><br />
            <a href="https://moodlift.nl/privacy-statement/" target="_blank">{t("Privacy Statement")}</a><br />
            <a href={props.language === 1 ? "https://moodlift.nl/nl/het-belang-van-wetenschappelijk-onderzoek-binnen-moodlift/" : "https://moodlift.nl/the-importance-of-scientific-research-within-caring-universities/"} target="_blank">{t("Wetenschappelijk onderzoek is verbonden met het gebruik van MoodLift")}</a><br />
            &copy; Copyright Vrije Universiteit Amsterdam
          </div>
          
        </div>
      </div>
    </div>
  )
}

export default Footer;
